<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="基地："
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="(item) in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="产品类型："
              prop="productTypeId"
            >
              <a-select
                v-model="form.productTypeId"
                placeholder="请选择产品类型"
                allow-clear
                show-search
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in productTypetions"
                  :key="item.productTypeId"
                >
                  {{ item.productTypeName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="计收时间:"
              prop="time"
            >
              <a-range-picker
                :value="form.time"
                :placeholder="['开始月份', '结束月份']"
                format="YYYY-MM"
                :mode="rangePickerMode"
                @panelChange="panelChange"
                @change="monthChange"
              />
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @check="checkResource"
          />
        </div>
      </div>
      <div class="search-form-right">
        <TableActions
          :actions="addActions"
          @add="addTaxIncome"
          @importData="ImportTables"
          @export="exportTaxIncome"
        />
      </div>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => index"
        :scroll="{ x: 1200 }"
        @change="handleTableChange"
      >
        <span
          slot="actions"
          slot-scope="text, record"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @edit="editRecord(record)"
            @delete="deleteRecord(record)"
          />
        </span>

        <template
          slot="taxRate"
          slot-scope="taxRate"
        >
          {{ taxRate+'%' }}
        </template>
      </a-table>
    </div>
    <EditTaxIncomRecord
      :init-data="initData"
      :dialog-title="dialogTitle"
      :visible="modalVisible"
      :loading="confirmLoading"
      :base-options="baseOptions"
      :product-typetions="productTypetions"
      :action-type="actionType"
      @cancel="handleCancel"
      @ok="handleOk"
    />
    <ImportTables
      :visible="importVisible"
      :loading="confirmLoading"
      @importCancel="handleCancel"
      @importOk="handleOk"
    />
  </div>
</template>

<script>
import { queryTaxIncome, deleteTaxIncome, exportTaxIncome } from '@/api/vocherIncome.js'
import EditTaxIncomRecord from './EditTaxIncomRecord.vue'
import {
  queryBases,
  queryProductTypeBySubsidy
} from '@/api/common.js'
import ImportTables from './ImportTables.vue'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'

const columns = [
  {
    title: '基地',
    dataIndex: 'baseName',
    key: 'baseName',
    width: '130px'
  },
  {
    title: '产品类型',
    dataIndex: 'productTypeName',
    key: 'productTypeName',
    width: '130px'
  },
  {
    title: '计收时间',
    dataIndex: 'date',
    key: 'date',
    width: '130px'
  },
  {
    title: '含税收入',
    dataIndex: 'taxIncome',
    key: 'taxIncome',
    width: '130px'
  },
  {
    title: '税率',
    dataIndex: 'taxRate',
    key: 'taxRate',
    width: '150px',
    scopedSlots: { customRender: 'taxRate' }
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    width: '150px'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '150px',
    scopedSlots: { customRender: 'actions' }
  }
]
const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'check'
  }
]

const addActions = [{
  title: '添加计收',
  type: 'primary',
  action: 'add',
  apis: ['@baseInfo/Add_Base']
},
{
  title: '导入',
  action: 'importData',
  type: 'primary',
  ghost: true,
  apis: ['@baseInfo/Add_Base']
},
{
  title: '导出',
  type: 'primary',
  action: 'export',
  ghost: true,
  apis: ['@baseInfo/Export_Bases']
}]

const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  }, {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]

export default {
  components: {
    EditTaxIncomRecord,
    ImportTables
  },
  data () {
    return {
      columns,
      dataSource: [],
      loading: false,
      pagination,
      baseId: 0,
      baseOptions: [],
      productTypetions: [],
      tableActions,
      addActions,
      modalVisible: false,
      confirmLoading: false,
      initData: null,
      dialogTitle: null,
      form: {
        baseId: undefined,
        productTypeId: undefined,
        time: []
      },
      rangePickerMode: ['month', 'month'],
      headerActions,
      importVisible: false,
      actionType: '0'
    }
  },
  created () {
    this.loading = true
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    excelDown,
    filterOption,
    inputKeydown,
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
      })
      await queryProductTypeBySubsidy({
        subsidyType: 2
      }).then((data) => {
        this.productTypetions = data
      })
    },
    checkResource () {
      this.pagination.current = 1
      this.fetchData()
    },
    // 异步获取数据
    async fetchData () {
      this.loading = true
      await queryTaxIncome({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.form
      }).then((data) => {
        this.dataSource = data.result ? data.result : []
        this.pagination.total = data.totalRecords
      })
      this.loading = false
    },
    editRecord (record) {
      this.modalVisible = true
      this.initData = record
      this.actionType = '0'
      this.dialogTitle = '编辑券类含税收入'
    },
    monthChange (value) {
      if (value.length === 0) {
        this.form.startYearMonth = null
        this.form.endYearMonth = null
        this.form.time = value
      }
    },
    addTaxIncome () {
      this.modalVisible = true
      this.initData = {}
      this.actionType = '1'
      this.dialogTitle = '添加券类含税收入'
    },
    deleteRecord (record) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          await deleteTaxIncome({ recordId: record.recordId }).then((data) => {
            if (data) {
              this.$message.success('删除成功!')
              this.fetchData()
            } else {
              this.$message.error('存在关联信息，无法删除!')
            }
          })
        }
      })
    },
    handleCancel () {
      this.modalVisible = false
      this.importVisible = false
    },
    handleOk () {
      this.handleCancel()
      this.fetchData()
    },
    async exportTaxIncome () {
      await exportTaxIncome({
        ...this.form
      }).then((data) => {
        this.excelDown(data, '券类含税收入')
      })
    },
    panelChange (value) {
      this.form.startYearMonth = value[0].format('YYYY-MM')
      this.form.endYearMonth = value[1].format('YYYY-MM')
      this.form.time = [this.form.startYearMonth, this.form.endYearMonth]
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    ImportTables () {
      this.importVisible = true
      this.fetchData()
    }
  }

}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}
</style>
